(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom_collection"] && !Shopify.designMode) return;
  try {
    const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flama-badge-info')) {
    customElements.define(
      'flama-badge-info',
      class extends HTMLElement {
        connectedCallback() {
          if (this.button) return;

          this.button = this.querySelector('button');
          const template = this.querySelector('template');

          if (
            !this.button ||
            !template ||
            !('showPopover' in HTMLElement.prototype)
          ) {
            this.hidden = true;
            return;
          }

          this.panel =
            template.content.firstElementChild.cloneNode(true);

          this.panel.id = `flama-badge-info-${crypto.randomUUID()}`;
          document.body.appendChild(this.panel);

          this.button.setAttribute('aria-controls', this.panel.id);

          this.positionPanel = () => {
            if (!this.panel.matches(':popover-open')) return;

            const anchor = this.button.getBoundingClientRect();
            const gap = 8;
            const margin = 12;
            const width = this.panel.offsetWidth;
            const height = this.panel.offsetHeight;

            const left = Math.max(
              margin,
              Math.min(
                anchor.right - width,
                window.innerWidth - width - margin
              )
            );

            let top = anchor.top - height - gap;

if (top < margin) {
  top = anchor.bottom + gap;
}

            top = Math.max(
              margin,
              Math.min(
                top,
                window.innerHeight - height - margin
              )
            );

            this.panel.style.left = `${left}px`;
            this.panel.style.top = `${top}px`;
          };

          this.onButtonClick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (this.panel.matches(':popover-open')) {
              this.panel.hidePopover();
            } else {
              this.panel.showPopover();
              this.positionPanel();
            }
          };

          this.onToggle = () => {
            const open = this.panel.matches(':popover-open');

            this.button.setAttribute(
              'aria-expanded',
              String(open)
            );
          };

          this.onPanelClick = (event) => {
            event.stopPropagation();
          };

          this.button.addEventListener(
            'click',
            this.onButtonClick
          );

          this.panel.addEventListener(
            'toggle',
            this.onToggle
          );

          this.panel.addEventListener(
            'click',
            this.onPanelClick
          );

          window.addEventListener(
            'resize',
            this.positionPanel
          );

          window.addEventListener(
            'scroll',
            this.positionPanel,
            true
          );
        }

        disconnectedCallback() {
          this.button?.removeEventListener(
            'click',
            this.onButtonClick
          );

          window.removeEventListener(
            'resize',
            this.positionPanel
          );

          window.removeEventListener(
            'scroll',
            this.positionPanel,
            true
          );

          this.panel?.remove();
          this.button = null;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
